import React from 'react';
import { IntroSection } from '../basic/IntroSection';
import { ArticleLoader } from '../articles/ArticleLoader';
import { ArticleFilter } from './ArticleFilter';

export const Home = () => (
    <div className="container-fluid">
        <IntroSection />
        <ArticleFilter />
        <ArticleLoader />
    </div>
);
